export enum TimePeriods {
  weekly = 'WEEKLY',
  monthly = 'MONTHLY',
  quarterly = 'QUARTERLY',
  yearly = 'YEARLY',
}
